import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_REPORTS_QUERY = gql`
  query pagedReports($pager: PagerInputNew, $filters: ReportsFilterInput) {
    pagedReports(pager: $pager, filters: $filters) {
      total
      values {
        ...report
      }
    }
  }
  ${Fragments.report}
`;

export const REPORTS_LIST_FILTERS_QUERY = gql`
  {
    reportsFilters @client {
      fullTextFilter {
        value
      }
      reportName {
        value
      }
      reportFriendlyName {
        value
      }
    }
  }
`;
